module.exports = __webpack_public_path__ + "img/SER-i-1-IV.092399b8.png";